import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-procedure-select-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './procedure-select-modal.component.html'
})
export class ProcedureSelectModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() title = 'Selecionar Procedimentos';
  @Input() procedures: { label: string; value: string | number | boolean }[] = [];
  @Input() selectedValues: string[] = [];

  @Output() confirm = new EventEmitter<string[]>();
  @Output() cancel = new EventEmitter<void>();

  searchTerm = '';
  tempSelected: Set<string> = new Set();
  filteredProcedures: { label: string; value: string | number | boolean }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen'] && this.isOpen) {
      this.tempSelected = new Set(this.selectedValues || []);
      this.searchTerm = '';
    }
    if (changes['isOpen'] || changes['procedures']) {
      this.updateFilteredProcedures();
    }
  }

  onSearchChange(term: string): void {
    this.searchTerm = term;
    this.updateFilteredProcedures();
  }

  private updateFilteredProcedures(): void {
    const procs = this.procedures || [];
    if (!this.searchTerm) {
      this.filteredProcedures = procs;
      return;
    }
    const term = this.searchTerm.toLowerCase();
    this.filteredProcedures = procs.filter(p => p.label.toLowerCase().includes(term));
  }

  isSelected(value: string | number | boolean): boolean {
    return this.tempSelected.has(String(value));
  }

  onToggle(value: string | number | boolean, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const strValue = String(value);
    if (checked) {
      this.tempSelected.add(strValue);
    } else {
      this.tempSelected.delete(strValue);
    }
  }

  onConfirm(): void {
    this.confirm.emit(Array.from(this.tempSelected));
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
